module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pageNotFound"
    }
  }, [_c('img', {
    staticClass: "background-img-404",
    attrs: {
      "src": require("../../../assets/icon/404.jpg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pageNotFound-content"
  }, [_c('div', {
    staticClass: "pageNotFound-label pageNotFound-label1"
  }, [_vm._v("哎呀，您访问的页面可能我们蛋糕师傅还未制作出来哟！")]), _vm._v(" "), _c('div', {
    staticClass: "pageNotFound-label pageNotFound-label2"
  }, [_vm._v("请刷新页面试试")])]), _vm._v(" "), _c('img')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64995f1a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/global/pageNotFound.vue
// module id = 576
// module chunks = 1